// IMPORT
    // MODULE(S)
        import React from 'react';
        import PropTypes from 'prop-types';
    // STYLE(S)
        import '../sass/TodoRecap.scss';



// MAIN CONTENT - FUNCTION / COMPONENT
    function TodoRecap({ list }) {


        // VARIABLE(S)
            const todo_total = list.length;
            const todo_left = list.filter(todo => !todo.complete).length;
            let message, color, className;


        // DILEMMA(S)
            if (todo_total > 0) {
                if (todo_left > 0) {
                    message = "You have " + todo_left + " task(s) left !";
                    color = "blue";
                } else {
                    message = "Congratulation ! You are done for today !";
                    color = "green";
                }
            } else {
                message = "You got nothing to do ?! Really ?!";
                color = "red";
            }
            className = "status " + color;


        // RETURN
            return (
                <div className="todoRecap">
                    <h5>Recap</h5>
                    <p className={className}>{message}</p>
                </div>
            )
    }
    export default TodoRecap;



// PROPTYPES
    TodoRecap.propTypes = {
        list: PropTypes.array
    }
